import classNames from "classnames";
import alertIcon from "../../../assets/alert-icon.svg";
import { getDisplayError } from "../../../lib/api/endpoints";
import StyledButton from "../buttons/StyledButton";
import styles from "./StyledError.module.css";
import { ReactNode } from "react";

const strings = {
  retry: "Retry",
};

type BaseProps = {
  errorTitle: string;
  refetch: () => void;
  variant?: "horizontal" | "vertical";
  footer?: ReactNode;
};

type Props = BaseProps &
  (
    | {
        error: unknown | unknown[];
        errorMessage?: never;
      }
    | { error?: never; errorMessage: string }
  );

export function StyledError({
  error,
  errorMessage,
  errorTitle,
  refetch,
  variant = "horizontal",
  footer,
}: Props) {
  return (
    <div
      className={classNames({
        [styles.error]: true,
        [styles.displayErrorAsColumn]: variant === "vertical",
      })}
    >
      <div
        className={classNames({
          [styles.content]: true,
          [styles.contentAsColumn]: variant === "vertical",
        })}
      >
        <img className={styles.image} src={alertIcon} alt="" />
        <div className={styles.errorRightContent}>
          <span className={styles.bold}>{errorTitle}</span>
          {errorMessage ? errorMessage : null}
          {error
            ? Array.isArray(error)
              ? error.map(getDisplayError).join(" ")
              : getDisplayError(error)?.message
            : null}
        </div>
        <StyledButton
          className={styles.retryButton}
          onClick={refetch}
          variant="secondary"
        >
          {strings.retry}
        </StyledButton>
      </div>
      {footer}
    </div>
  );
}
